import React, { useEffect, useState } from "react";
import {
  Calendar,
  Receipt,
  DollarSign,
  Wallet,
  ArrowRightLeft,
  Copy,
  Info,
  AlertOctagon,
  AlertTriangle,
  CheckCircle2,
  BellRing,
  BookOpen,
  ChevronRight,
} from "lucide-react";
import { Button } from "../../Components/Tags/Tags";
import Header from "../../Components/Header";
import Seo from "../../Components/SeoComponent/Seo";
import {
  RequstFundService,
  retriveFundService,
  SlipPreviewService,
  updateGst,
} from "../../Services/AddBankAC.js/fundRequest";
import SlipViewModal from "./SlipViewModal";
import { FaInbox } from "react-icons/fa";
import { IoIosCopy } from "react-icons/io";
import moment from "moment";
import { FaInfoCircle } from "react-icons/fa";
import { showSuccessToast, showErrorToast } from "../../utils/toastUtils";
import Loader from "../../Loader";
import PaginationData from "../../Components/PaginationData";
import {
  ArrowRight,
  BanknoteArrowDown,
  Eye,
  InfoIcon,
  ShieldCheck,
  X,
  XCircle,
} from "lucide-react";
import { MoneySharp } from "@mui/icons-material";
import PaymentSlipModal from "../../Components/fund/PaymentSlip";
import ImageSlipModal from "../../Components/fund/PaymentSlipImg";
import GstModal from "../../Components/GstModal/GstModal";
import LowBalanceAlertModal from "../../Components/LowBalanceAlert/LowBalanceAlert";
import PaymentInstructionsModal from "./PaymentInstructions";

const AddFund = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [paySlip, setPaySlip] = useState(null);
  const [paymode, setPaymode] = useState("online");
  const [amount, setAmount] = useState("2000");
  const [utrNo, setUtrNo] = useState("");

  const [txnDate, setTxnDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split("T")[0]; // Format YYYY-MM-DD
  });

  const [fundData, setFundData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [paginationData, setPaginationData] = useState();
  const [errors, setErrors] = useState({});
  const [filename, setFileName] = useState("");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  // const [isCopied, setIsCopied] = useState(false)
  const [isQrClicked, setIsQrClicked] = useState(false);
  const [selectedFundId, setSelectedFundId] = useState("");
  const [imagePreviewClicked, setImagePreviewClicked] = useState(false);
  const [showSlip, setShowSlip] = useState("none");
  const [slipDetailsForUpi, setSlipdetailsForUpi] = useState(null);
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [imageLoading, setImageLoading] = useState(false);
  const [showGstModal, setShowGstModal] = useState(false);
  const [openInstructionModal, setOpenInstructionModal] = useState(false)

  // const openModal = () => setIsModalOpen(true);

  const closeModal = () => {
    setFileName("");
    setImageUrl("");
    setIsModalOpen(false);
  };

  const copyText = (data) => {
    navigator.clipboard.writeText(data).then(() => showSuccessToast("Copied!"));
  };

  async function SlipPreview() {
    setImageLoading(true);
    const response = await SlipPreviewService(filename);
    setImageUrl(response.dataUri);
    setImageLoading(false);

    return;
  }
  useEffect(() => {
    SlipPreview();
  }, [showSlip]);

  const handleDateChange = (e) => {
    setTxnDate(e.target.value);
  };

  // Validate Form Input
  const validateForm = () => {
    const newErrors = {};

    // Paymode is required
    if (!paymode) newErrors.paymode = "Paymode is required";

    // Validate PaySlip & UTR No only for Online Payment
    if (paymode === "online") {
      if (!paySlip) {
        newErrors.slip = "PaySlip is required.";
      } else if (paySlip.size > 1024000) {
        newErrors.slip = "PaySlip must be smaller than 1 MB.";
      }

      if (!utrNo) newErrors.utrNo = "Utr No is required.";
    }

    // Amount Validation for all paymodes
    const amt = Number(amount);

    if (!amt || isNaN(amt)) {
      newErrors.amount = "Amount must be a valid number.";
    } else if (amt < 1000) {
      newErrors.amount =
        paymode === "qr"
          ? "Amount must be at least ₹1000 for QR."
          : "Amount must be at least ₹1000.";
    }

    // Txn Date Validation for all paymodes
    // if (!txnDate) newErrors.txnDate = 'Txn Date must be a valid date.';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handlesubmit = async () => {
    if (!validateForm()) return;

    try {
      setIsLoading(true);
      const txnDate2 = new Date(txnDate).toLocaleDateString("en-CA");
      const formData = new FormData();
      formData.append("slip", paySlip);
      formData.append("mode", paymode);
      formData.append("amount", amount);
      formData.append("utr", utrNo);
      formData.append("txn_date", txnDate2);

      const response = await RequstFundService(formData);

      if (response.status === 422 || response?.status?.code === 422) {
        const err = response?.error || response?.data?.errors;

        const errMsg = Object.values(err || {})[0]?.[0];
        showErrorToast(errMsg || response.data?.error || "Validation Failed");
        return;
      }

      if (response.status === 500) {
        showErrorToast(
          response.data?.error ||
            "Internal Server Error. Please try again later.",
        );
        return;
      }

      const paymentUrl = response.data?.payment_url;
      const walletAmount = response.data?.wallet?.amount || 0;

      if (paymode === "qr" && walletAmount < 1000) {
        showErrorToast(
          response.data?.error || "Amount must not be less than 1000",
        );
        return;
      }

      // Call RetrieveFundData first before resetting the form
      await RetrieveFundData();

      resetForm();
      showSuccessToast(response.data?.message || "Fund request added");

      // Redirect to Payment URL if available
      if (paymentUrl) {
        window.location.href = paymentUrl;
      }
    } catch (error) {
      if (error.response) {
        showErrorToast(
          error.response.data?.message || `Error: ${error.response.status}`,
        );
      } else if (error.request) {
        showErrorToast(
          "No response received from server. Please check your network.",
        );
      } else {
        showErrorToast(error.message || "Something went wrong.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const resetForm = () => {
    setPaySlip(null);
    setPaymode("");
    setAmount("");
    setUtrNo("");
    setTxnDate("");
  };

  // Retrive Fund Data
  const RetrieveFundData = async (page = currentPage) => {
    try {
      setIsLoading(true);
      const response = await retriveFundService(page);
      if (response && response.data) {
        setFundData(response.data.data || []);
        setPaginationData(response.data.pagination || {});
        setCurrentPage(response.data.pagination.current_page || 1);
        setLastPage(response.data.pagination.last_page || 1);
      }
    } catch (error) {
      showErrorToast(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    RetrieveFundData();
  }, [currentPage]);
  // ENd

  function handlePage(page) {
    setCurrentPage(page);
  }

  const handleCopy = (orderId) => {
    if (!orderId) {
      showErrorToast("No Order ID available to copy!");
      return;
    }
    // Create a temporary textarea to copy the text
    const tempTextarea = document.createElement("textarea");
    tempTextarea.value = orderId;
    document.body.appendChild(tempTextarea);
    tempTextarea.select();
    document.execCommand("copy");
    document.body.removeChild(tempTextarea);
    showSuccessToast("Copied to clipboard!");
  };

  return (
    <>
      <Seo />
      {isLoading && <Loader />}
      <Header heading="Add Fund" />

      <div className="grid grid-cols-1 py-4 items-stretch gap-4 justify-items-stretch md:grid-cols-2">
        {/* Form starts here */}
        <div className="flex w-full rounded-3xl overflow-hidden shadow-[0_30px_80px_-15px_rgba(0,0,0,0.6)] flex-col font-sans pb-2 justify-start items-center gap-2">
          {/* HEADER STRIP */}
          <div className="w-full bg-gradient-to-r  from-purple-600 to-blue-700 px-6 py-2 flex items-center gap-3">
            <div className="h-11 w-11 rounded-full bg-black/30 backdrop-blur flex items-center justify-center">
              <BanknoteArrowDown className="h-6 w-6 text-white" />
            </div>
            <h2 className="text-white text-xl font-extrabold tracking-widest uppercase">
              Add Fund
            </h2>
          </div>

          <div className="flex w-full flex-col font-sans px-4 md:px-8 lg:px-12 py-2 justify-start items-start gap-6 ">
            {/* Pay Mode Selection */}
            <div className="w-full flex flex-col gap-2">
              <label
                htmlFor="paymode"
                className="flex justify-between items-center font-sans font-semibold"
              >
                <div>
                  Select Pay Mode
                  <span className="text-red-700 font-bold">*</span>
                </div>
                <button
                  onClick={() => setOpenInstructionModal(true)}
                  className="group inline-flex items-center gap-2.5 px-5 py-2.5 bg-blue-600 hover:bg-slate-800 text-white text-sm font-semibold rounded-xl shadow-sm hover:shadow-md transition-all duration-200 active:scale-95 cursor-pointer"
                >
                  {/* Primary Icon */}
                  <BookOpen
                    size={18}
                    className="text-slate-200 group-hover:text-white transition-colors"
                  />

                  {/* Label */}
                  <span>Fund Request Instructions</span>

                  {/* Trailing Micro Arrow */}
                  <ChevronRight
                    size={16}
                    className="text-slate-200 group-hover:translate-x-0.5 group-hover:text-white transition-all"
                  />
                </button>
              </label>
              <select
                value={paymode}
                className="
                  w-full rounded-xl border border-gray-300 bg-white/70
                  px-4 pr-2 py-3 text-[16px] text-gray-900
                  shadow-sm backdrop-blur
                  transition-all duration-200
                  focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/30
                  focus:outline-none
                  disabled:cursor-not-allowed disabled:opacity-60
                "
                name="paymode"
                id="paymode"
                onChange={(e) => setPaymode(e.target.value)}
              >
                <option value="">Select Pay Mode</option>
                <option value="online">Bank Transfer</option>
                <option value="qr">UPI</option>
              </select>

              {paymode === "online" && (
                <div className="text-sm font-semibold text-red-600 flex items-center gap-1">
                  {" "}
                  <Info size={18} /> Fund Will Be Added in 50 Minutes.
                </div>
              )}

              {paymode === "online" && (
                <div className="font-sans flex flex-wrap gap-2 items-center text-xs font-semibold leading-none">
                  <p className="bg-green-50 hover:bg-green-700 hover:text-green-50 hover:border-none text-green-700 border-[1px] border-dashed border-green-700 px-2 rounded-md flex gap-1 items-center">
                    <strong>A/C :</strong> 50200120431741{" "}
                    <span
                      onClick={() => copyText("50200120431741")}
                      className="p-1 flex items-center gap-2  cursor-pointer hover:font-extrabold"
                    >
                      <Copy size={20} />
                    </span>
                  </p>
                  <p className="bg-green-50 hover:bg-indigo-700 hover:text-green-50 hover:border-none text-green-700 border-[1px] border-dashed border-green-700 px-2 rounded-md flex gap-1 items-center">
                    <strong>IFSC :</strong> HDFC0000344{" "}
                    <span
                      onClick={() => copyText("HDFC0000344")}
                      className="p-1  flex items-center gap-2  cursor-pointer hover:font-extrabold"
                    >
                      <Copy size={20} />
                    </span>
                  </p>
                  <p className="bg-green-50 text-green-700 border-[1px] border-dashed border-green-700 hover:bg-green-700 hover:text-green-50 hover:border-none px-2 rounded-md flex gap-1 items-center">
                    <strong> UPI: </strong>idspay@ptyes{" "}
                    <span className=" flex items-center gap-1 cursor-pointer hover:font-extrabold">
                      <div
                        className="p-1"
                        onClick={() => copyText("idspay@ptyes")}
                      >
                        <Copy size={20} />
                      </div>

                      <div onClick={() => setIsQrClicked(true)} className="p-1">
                        <Eye size={20} />
                      </div>
                    </span>
                  </p>
                </div>
              )}

              {paymode === "qr" && (
                <div className="text-sm font-semibold text-red-600 flex items-center gap-1">
                  {" "}
                  <Info size={18} /> UPI Mode is Under Maintenance,{" "}
                  <span className="text-green-600 "> Use Bank Transfer</span>
                </div>
              )}

              {isQrClicked && (
                <QrModal
                  showQr={isQrClicked}
                  setIsQrClicked={() => setIsQrClicked(false)}
                />
              )}

              {paymode
                ? null
                : errors.paymode && (
                    <p className="text-red-600 text-sm font-mono">
                      {errors.paymode}
                    </p>
                  )}
            </div>

            {/* Conditionally Show Slip Field (Only for Online) */}

            {/* Amount Field */}
            <div className="flex flex-col w-full gap-4">
              <div className="grid grid-cols-2 gap-6">
                <div className="w-full flex flex-col gap-2">
                  <label htmlFor="amount" className=" font-sans font-semibold">
                    Amount<span className="text-red-700 font-bold">*</span>
                  </label>
                  <input
                    type="number"
                    name="amount"
                    id="amount"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    placeholder="Eg 1000-100000"
                    className="
                    w-full rounded-xl border border-gray-600 bg-white/70
                    px-4 py-3 text-[16px] text-gray-900
                    placeholder:text-gray-400
                    shadow-sm backdrop-blur
                    transition-all duration-200
                    focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/30
                    focus:outline-none
                    disabled:cursor-not-allowed disabled:opacity-60
                  "
                  />

                  {Number(amount) >= 1000
                    ? null
                    : errors.amount && (
                        <p className="text-red-600 text-sm font-mono">
                          {errors.amount}
                        </p>
                      )}
                </div>

                {paymode === "online" && (
                  <div className="w-full flex flex-col gap-2">
                    <label
                      htmlFor="slip"
                      className="block font-sans font-semibold"
                    >
                      Upload PaySlip
                      <span className="text-red-700 font-bold">*</span>
                    </label>
                    <input
                      type="file"
                      name="slip"
                      id="slip"
                      onChange={(e) => setPaySlip(e.target.files[0])}
                      className="px-2 border border-gray-400  py-2 rounded-xl"
                    />
                    {errors.slip && (
                      <p className="text-red-600 text-sm font-mono">
                        {errors.slip}
                      </p>
                    )}
                  </div>
                )}
              </div>

              {/* Button Grid/Flex */}
              <div className="flex flex-wrap gap-2.5">
                {[2000, 5000, 10000, 20000, 50000].map((item) => {
                  const isSelected = Number(amount) === item; // Assuming 'amount' is your state variable

                  return (
                    <button
                      key={item}
                      onClick={() => setAmount(item)}
                      type="button"
                      className={`
            px-4 py-2 text-sm font-semibold rounded-lg transition-all duration-200
            border ${
              isSelected
                ? "bg-indigo-600 text-white border-indigo-600 shadow-sm shadow-indigo-100"
                : " hover:bg-indigo-600 border border-gray-400 hover:border-indigo-300 hover:text-white "
            }
          `}
                    >
                      ₹{item.toLocaleString("en-IN")}
                    </button>
                  );
                })}
              </div>
            </div>

            <div className="flex w-full gap-6">
              {/* Conditionally Show UTR No Field (Only for Online) */}
              {paymode === "online" && (
                <div className="w-full flex flex-col gap-2">
                  <label
                    htmlFor="utrNo"
                    className="block font-sans font-semibold text-nowrap"
                  >
                    UTR No<span className="text-red-700 font-bold">*</span>{" "}
                    <span className="text-blue-600 text-xs text-nowrap">
                      (Should Be Unique)
                    </span>
                  </label>
                  <input
                    type="text"
                    name="utrNo"
                    id="utrNo"
                    value={utrNo}
                    onChange={(e) => setUtrNo(e.target.value)}
                    placeholder="Enter UTR No."
                    className="
                      w-full rounded-xl border border-gray-800 bg-white/70
                      px-4 py-3 text-sm text-gray-900
                      placeholder:text-gray-400
                      shadow-sm backdrop-blur
                      transition-all duration-200
                      focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/30
                      focus:outline-none
                      disabled:cursor-not-allowed disabled:opacity-60
                    "
                  />
                  {utrNo
                    ? null
                    : errors.utrNo && (
                        <p className="text-red-600 text-sm font-mono">
                          {errors.utrNo}
                        </p>
                      )}
                </div>
              )}

              {/* Transaction Date Field */}
              <div className="w-full flex flex-col gap-2">
                <label
                  htmlFor="txnDate"
                  className="block font-sans font-semibold"
                >
                  Txn Date<span className="text-red-700 font-bold">*</span>
                </label>
                <input
                  type="date"
                  name="txnDate"
                  readOnly
                  id="txnDate"
                  value={txnDate}
                  onChange={handleDateChange}
                  className="
                  w-full rounded-xl border border-gray-600 bg-white/70
                  px-4 py-3 text-sm text-gray-900
                  shadow-sm backdrop-blur
                  transition-all duration-200
                  focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/30
                  focus:outline-none
                "
                />
                {errors.txnDate && (
                  <p className="text-red-600 text-sm font-mono">
                    {errors.txnDate}
                  </p>
                )}
              </div>
            </div>

            <div className="w-full ">
              <Button
                color="primary"
                onClick={handlesubmit}
                disabled={isLoading}
                className="w-full flex justify-center py-3 mt-5 text-lg  bg-gradient-to-r  from-purple-600 to-blue-700 text-white font-bold rounded-2xl px-3 shadow-lg hover:from-blue-900 hover:to-blue-600"
              >
                {isLoading ? (
                  "Submitting..."
                ) : (
                  <div className="flex  gap-4 items-center">
                    <div>Add Funds Now</div>
                    <span>
                      <ArrowRight />
                    </span>
                  </div>
                )}
              </Button>
            </div>
            <div className="w-full flex rounded-xl  justify-center gap-3 text-sm text-gray-500">
              <span>
                <ShieldCheck size={20} className="text-green-600" />
              </span>

              <p>Your payments are 100% Secure and encrypted </p>
            </div>
          </div>
          <div className="bg-gradient-to-r from-purple-600 to-blue-600 h-1" />
        </div>

        {/* instructions */}

        <div className="w-full flex justify-center items-stretch px-4 ">
          <div className="relative w-full">
            {/* CARD */}
            <div className="relative rounded-3xl overflow-hidden shadow-[0_30px_80px_-15px_rgba(0,0,0,0.6)]">
              {/* HEADER STRIP */}
              <div className="bg-gradient-to-r  from-purple-600 to-blue-700 px-6 py-2 flex items-center gap-3">
                <div className="h-11 w-11 rounded-full bg-black/30 backdrop-blur flex items-center justify-center">
                  <InfoIcon className="h-6 w-6 text-white " />
                </div>
                <h2 className="text-white text-xl font-extrabold tracking-widest uppercase">
                  Important Instructions
                </h2>
              </div>

              {/* BODY */}
              <div className="bg-gradient-to-br from-[#dcdddf] via-[#c7c8c7] to-gray-200 px-6 py-6 text-black">
                <div className="space-y-4 text-[16px]">
                  <div className="leading-none">
                    <p className="flex gap-3 items-start">
                      <span className="h-2.5 w-3.5 mt-2 rounded-full bg-purple-700" />
                      <span className="leading-none">
                        Use only your{" "}
                        <b className="text-purple-700">
                          own bank account / UPI ID
                        </b>{" "}
                        that is registered in your company or individual name.
                      </span>
                    </p>
                    <p className="ml-6">
                      ➜ Third-party or{" "}
                      <b className="text-purple-700">unknown UPI payments</b>{" "}
                      may be rejected or put on hold.
                    </p>
                  </div>

                  <div className="leading-none">
                    <p className="flex gap-3 items-start">
                      <span className="h-2.5 w-2.5 mt-2 rounded-full bg-purple-700" />
                      <span>After successful UPI payment:</span>
                    </p>
                    <p className="ml-6">
                      • <b className="text-purple-700">Wallet balance</b> is
                      usually updated automatically within a few minutes
                    </p>
                    <p className="ml-6">
                      • In rare cases, it may take up to 24 working hours due to
                      bank or <b className="text-purple-700">NPCI delays</b>
                    </p>
                  </div>

                  <div className="leading-none">
                    <p className="flex gap-3 items-start">
                      <span className="h-2.5 w-3.5 mt-2 rounded-full bg-purple-700" />
                      <span>
                        If the amount is debited from your bank but not
                        reflected in the wallet:
                      </span>
                    </p>
                    <p className="ml-6">
                      •{" "}
                      <b className="text-purple-700">
                        Keep the UPI transaction ID (UTR)
                      </b>
                    </p>
                    <p className="ml-6">
                      • Raise a support ticket or{" "}
                      <b className="text-purple-700">contact IDSPay</b> support
                      with payment details
                    </p>
                  </div>

                  <p className="flex gap-3 items-start">
                    <span className="h-2.5 w-3.5 mt-2 rounded-full bg-purple-700" />
                    <span className="leading-none">
                      <b className="text-purple-700">
                        Do not attempt multiple payments
                      </b>{" "}
                      for the same request unless advised by{" "}
                      <b className="text-purple-700">IDSPay support</b>.
                    </span>
                  </p>
                </div>

                {/* <div className="mt-4 font-mono flex items-center gap-2 p-2 border-l-[15px] border-l-green-600 font-bold rounded-xl  text-white">
                  <p className="p-2 rounded-full  bg-white/10">
                    <AlertTriangle />
                  </p>

                  <span>Don't Miss out on GST invoice. Submit Details now</span>
                </div> */}

                <GstInvoiceCard />
                <LowBalanceAlertCard />
              </div>

              {/* FOOTER STRIP */}
              <div className="bg-gradient-to-r from-indigo-600 via-purple-500 to-blue-500 h-1" />
            </div>
          </div>
        </div>
      </div>

      {fundData?.length > 0 ? (
        <>
          <div className="w-full  mx-auto px-4 py-6">
            {/* Modern Section Header */}
            <div className="sm:flex sm:items-center sm:justify-between border-b border-gray-100 pb-5 mb-2">
              <div>
                <h2 className="text-xl font-bold text-gray-900 tracking-tight sm:text-2xl flex items-center gap-2">
                  <ArrowRightLeft className="h-6 w-6 text-blue-600" />
                  Fund Request History
                </h2>
                <p className="mt-1.5 text-sm text-gray-500">
                  Overview of your digital wallet recharges, transaction
                  statuses, and payment modes.
                </p>
              </div>
              <div className="mt-4 sm:mt-0">
                {/* Optional space for a filter input / refresh button / action button */}
              </div>
            </div>

            {/* Table Container */}
            <div className="hidden md:block overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
              <table className="min-w-full divide-y divide-gray-200 text-sm">
                <thead className="bg-gray-50 text-gray-700 font-medium">
                  <tr>
                    <th
                      scope="col"
                      className="px-4 py-3.5 text-center font-semibold w-12"
                    >
                      SNo
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-3.5 text-left font-semibold"
                    >
                      <span className="flex items-center gap-1.5">
                        <Calendar className="h-4 w-4 text-gray-400" /> Request
                        Date
                      </span>
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-3.5 text-center font-semibold"
                    >
                      Status
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-3.5 text-center font-semibold"
                    >
                      <div className="flex items-center gap-1 text-nowrap justify-center">
                        <Eye size={16} />
                        View Slip
                      </div>
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-3.5 text-left font-semibold"
                    >
                      Paymode
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-3.5 text-right font-semibold"
                    >
                      <span className="flex items-center justify-end gap-1.5">
                        <DollarSign className="h-4 w-4 text-gray-400" /> Amount
                      </span>
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-3.5 text-left font-semibold"
                    >
                      Order ID
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-3.5 text-left font-semibold"
                    >
                      UTR/RRN
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-3.5 text-left font-semibold"
                    >
                      <span className="flex items-center gap-1.5">
                        <Wallet className="h-4 w-4 text-gray-400" /> Wallet
                        Transaction Id
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white text-gray-600">
                  {fundData.map((item, index) => (
                    <tr
                      key={index}
                      className="hover:bg-gray-50/70 transition-colors"
                    >
                      {/* SNo */}
                      <td className="px-4 py-3.5 text-center font-medium text-gray-900">
                        {(currentPage - 1) * paginationData?.per_page +
                          index +
                          1}
                      </td>

                      {/* Request Date */}
                      <td className="px-4 py-3.5 whitespace-nowrap text-gray-900">
                        {moment(item?.created_at).format("DD/MM/YYYY")}
                      </td>

                      {/* Status */}
                      <td className="px-4 py-3.5">
                        <div className="flex items-center justify-center gap-2">
                          <span
                            className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold capitalize tracking-wide shadow-sm ${
                              item?.status?.value === "approved"
                                ? "bg-green-100 text-green-800 border border-green-200"
                                : item?.status?.value === "pending"
                                  ? "bg-amber-100 text-amber-800 border border-amber-200"
                                  : "bg-red-100 text-red-800 border border-red-200"
                            }`}
                          >
                            {item?.status?.value}
                          </span>

                          {/* Status Info Tooltip */}
                          <div className="relative group flex items-center">
                            <Info className="h-4 w-4 text-gray-400 hover:text-gray-600 cursor-pointer transition-colors" />
                            <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 hidden group-hover:block z-30 bg-gray-900 text-white text-xs px-2.5 py-1.5 rounded shadow-lg w-max max-w-xs whitespace-normal font-normal">
                              {item?.remarks || "No remarks"}
                              <div className="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-gray-900"></div>
                            </div>
                          </div>
                        </div>
                      </td>

                      {/* View Slip */}
                      <td className="p-1 text-center">
                        {/* <button
                          onClick={() => {
                            openModal();
                            setFileName(item?.pay_slip?.[0]?.file);
                          }}
                          className="inline-flex items-center gap-1 px-3 py-1 bg-emerald-600 hover:bg-emerald-700 text-white text-xs font-medium rounded-md shadow-sm transition-colors"
                        >
                          <Receipt className="h-3 w-3" />
                          Slip
                        </button> */}

                        <button
                          onClick={() => {
                            setShowSlip(item?.mode);
                            setFileName(item?.pay_slip?.[0]?.file);
                            setSlipdetailsForUpi(item?.qr_payment);
                            setPaymentStatus(item?.status?.value);
                          }}
                          className=" rounded-md px-3 py-1 hover:bg-blue-200 transition"
                        >
                          <img
                            className={
                              item?.mode === "online"
                                ? "w-6 h-auto"
                                : "w-12 h-auto"
                            }
                            src={
                              item?.mode === "online"
                                ? "https://cdn-icons-png.flaticon.com/128/10436/10436288.png"
                                : "https://upload.wikimedia.org/wikipedia/commons/6/6f/UPI_logo.svg"
                            }
                            alt="bank and upi"
                          />
                        </button>
                      </td>

                      {/* Paymode */}
                      <td className="px-4 py-3.5 font-medium uppercase text-xs tracking-wider text-gray-500">
                        {item?.mode === "online"
                          ? "Bank Transfer"
                          : "UPI" || "N/A"}
                      </td>

                      {/* Amount */}
                      <td className="px-4 py-3.5 text-right font-semibold text-gray-900">
                        ₹{item?.amount}
                      </td>

                      {/* Order ID */}
                      <td className="px-4 py-3.5 font-mono text-xs text-gray-500">
                        {item?.qr_payment?.order_status_response
                          ? (() => {
                              try {
                                const parsed = JSON.parse(
                                  item.qr_payment.order_status_response,
                                );
                                return parsed?.data?.order_id || "N/A";
                              } catch (e) {
                                return "N/A";
                              }
                            })()
                          : "N/A"}
                      </td>

                      {/* UTR with Custom Tooltip */}
                      <td className="px-4 py-3.5">
                        {item?.qr_payment?.order_status_response ? (
                          (() => {
                            try {
                              const parsed = JSON.parse(
                                item.qr_payment.order_status_response,
                              );
                              return (
                                <div className="flex items-center gap-1.5 relative group">
                                  <span className="font-mono text-xs text-gray-500">
                                    {parsed?.data?.utr || "N/A"}
                                  </span>

                                  <Info className="h-4 w-4 text-blue-500 hover:text-blue-600 cursor-pointer transition-colors" />

                                  {/* Tooltip Card */}
                                  <div className="absolute bottom-full left-0 mb-2 hidden group-hover:block z-30 bg-white text-gray-800 text-xs p-3 rounded-lg shadow-xl border border-gray-200 w-52 space-y-1 font-normal">
                                    <div className="border-b border-gray-100 pb-1 mb-1 font-semibold text-gray-900">
                                      Transaction Details
                                    </div>
                                    <div>
                                      <span className="text-gray-400 font-medium">
                                        Customer:
                                      </span>{" "}
                                      {parsed?.data?.customer_name}
                                    </div>
                                    <div>
                                      <span className="text-gray-400 font-medium">
                                        Amount:
                                      </span>{" "}
                                      ₹{parsed?.data?.txn_amount}
                                    </div>
                                    <div>
                                      <span className="text-gray-400 font-medium">
                                        Date:
                                      </span>{" "}
                                      {parsed?.data?.txn_date}
                                    </div>
                                    <div>
                                      <span className="text-gray-400 font-medium">
                                        Status:
                                      </span>{" "}
                                      <span className="text-emerald-600 font-medium">
                                        {parsed?.data?.txn_status}
                                      </span>
                                    </div>
                                    <div className="text-[10px] text-gray-400 italic pt-1">
                                      {parsed?.data?.description}
                                    </div>
                                    <div className="absolute top-full left-4 border-4 border-transparent border-t-white"></div>
                                    <div className="absolute top-full left-4 border-4 border-transparent border-t-gray-200 -z-10 translate-y-[1px]"></div>
                                  </div>
                                </div>
                              );
                            } catch (e) {
                              return <span className="text-gray-400">N/A</span>;
                            }
                          })()
                        ) : (
                          <span className="text-gray-400">N/A</span>
                        )}
                      </td>

                      {/* Wallet Transaction ID */}
                      <td className="px-4 py-3.5">
                        <div className="flex items-center justify-between gap-2 max-w-[180px]">
                          <span className="font-mono text-xs text-gray-500 truncate">
                            {item?.transaction_ids?.length > 0
                              ? item?.transaction_ids[0]?.order_id
                              : "N/A"}
                          </span>
                          {item?.transaction_ids?.length > 0 && (
                            <button
                              onClick={() =>
                                handleCopy(item?.transaction_ids[0]?.order_id)
                              }
                              className="text-gray-400 hover:text-blue-600 p-1 rounded hover:bg-gray-50 transition-all"
                              title="Copy ID"
                            >
                              <Copy className="h-3.5 w-3.5" />
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="md:hidden mt-2 space-y-2">
            {fundData.map((item, index) => {
              const parsed = item?.qr_payment?.order_status_response
                ? (() => {
                    try {
                      return JSON.parse(item.qr_payment?.order_status_response);
                    } catch {
                      return {};
                    }
                  })()
                : {};

              return (
                <div
                  key={index}
                  className="bg-white shadow-lg rounded-xl p-2 border border-blue-200"
                >
                  <div className="flex justify-between text-sm">
                    <span>
                      SNo:{" "}
                      {(currentPage - 1) * paginationData?.per_page + index + 1}
                    </span>
                    <p>
                      <strong>Req Date:</strong>
                      {moment(item?.created_at).format("DD/MM/YYYY")}
                    </p>
                  </div>
                  <div className="mt-2">
                    <div className="flex justify-between text-sm">
                      <p>
                        <strong>Status:</strong>{" "}
                        <span
                          className={`px-1 py-0 rounded text-white ${item.status?.value === "approved" ? "bg-green-500" : item.status?.value === "pending" ? "bg-yellow-500" : "bg-red-500"}`}
                        >
                          {item?.status?.value}
                        </span>
                      </p>
                      <p>
                        <strong>Paymode:</strong> {item?.mode}
                      </p>
                    </div>
                    <div className="flex justify-between text-sm">
                      <p>
                        <strong>Amount:</strong> ₹{item?.amount}
                      </p>
                      <p>
                        <strong>Order ID:</strong>{" "}
                        {parsed?.data?.order_id || "N/A"}
                      </p>
                    </div>
                    <p className="text-sm">
                      <strong>UTR:</strong> {parsed?.data?.utr || "N/A"}
                    </p>
                    <p className="text-sm">
                      <strong>Wallet Txn ID:</strong>{" "}
                      {item?.transaction_ids?.[0]?.order_id || "N/A"}
                    </p>
                    <div className="flex justify-between text-sm">
                      <p
                        className="text-blue-500 text-sm mt-1 cursor-pointer"
                        // onClick={openModal}
                      >
                        View Slip
                      </p>
                      <button
                        onClick={() =>
                          handleCopy(
                            item?.transaction_ids?.[0]?.order_id || "N/A",
                          )
                        }
                        className="mt-2 text-sm text-blue-600 underline"
                      >
                        Copy Txn ID
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      ) : (
        <div className="flex flex-col items-center mt-5">
          <FaInbox className="text-3xl" />
          <p>No Fund Data Available</p>
        </div>
      )}
      <PaymentSlipModal
        paymentData={slipDetailsForUpi}
        isOpen={showSlip === "qr"}
        status={paymentStatus}
        onClose={() => setShowSlip("none")}
      />
      <ImageSlipModal
        fileUrl={imageUrl}
        imgPreviewLoading={imageLoading}
        isOpen={showSlip === "online"}
        onClose={() => setShowSlip("none")}
      />

      <PaginationData
        currentPage={currentPage}
        lastPage={lastPage}
        handlePage={handlePage}
      />
      <SlipViewModal
        isOpen={isModalOpen}
        onClose={closeModal}
        imageUrl={imageUrl}
      />

      <PaymentInstructionsModal isOpen={openInstructionModal} onClose={() => setOpenInstructionModal(false)}/>
    </>
  );
};

export default AddFund;

const QrModal = ({ showQr, setIsQrClicked }) => {
  if (!showQr) return null;

  return (
    <div className="inset-0 fixed z-[999] flex items-center justify-center ">
      <div className="relative w-full h-full flex items-center justify-center ">
        <div className="absolute  w-full h-full z-30 bg-black/50 backdrop-blur-sm"></div>

        <div className="w-fit relative z-40 bg-white rounded-2xl p-6 ">
          <button
            onClick={() => setIsQrClicked()}
            className="absolute bg-blue-50 hover:bg-rose-50 hover:text-rose-700  border-blue-600 text-blue-600 rounded-full right-3 top-2 p-1"
          >
            <XCircle />
          </button>

          <div className="mt-4">
            <div className="flex my-2 items-center justify-between rounded-lg bg-emerald-50/80 border border-emerald-100 px-4 py-2.5 text-emerald-900">
              <span className="text-sm font-medium">
                Minimum Payment Required
              </span>
              <span className="font-bold text-emerald-700">₹2,000</span>
            </div>{" "}
            <img
              className="w-[450px] h-[450px] rounded-md"
              src="/media/idspay-qr.jpeg"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const GstInvoiceCard = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleApiCall = async (payload) => {
    // Payload will look exactly like: { "gst_number": "07AABCF8078M1Z3" }
    console.log("Submitting Payload to API:", payload);

    try {
      const res = await updateGst(payload);

      if (res) {
        console.log(res);
      }

      if (res?.status?.code === 200 || res?.status === true) {
        showSuccessToast(res?.message || res?.data?.message);
        setIsModalOpen(false);
      } else {
        let err = res?.data?.errors || res?.errors;

        err &&
          Object.values(err).forEach((element) => {
            showErrorToast(element[0]);
          });

        showErrorToast(res?.data?.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="flex mt-6 flex-col sm:flex-row md:flex-col 2xl:flex-row items-center justify-between border border-gray-200 rounded-xl p-4 bg-white w-full max-w-5xl mx-auto gap-4 sm:gap-6">
      {/* Left Section: Invoice Graphic Thumbnail */}
      <div className="flex-shrink-0 w-32 h-20 bg-white border border-gray-100 rounded shadow-sm flex flex-col items-center p-2 relative overflow-hidden">
        {/* Emblem placeholder */}
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/5/55/Emblem_of_India.svg"
          alt="india embelem"
          className="w-3 h-4 rounded-sm mb-1"
        />
        {/* Header lines */}
        <div className="h-1 bg-gray-200 rounded w-1/2 mb-1"></div>
        <div className="h-1 bg-gray-200 rounded w-1/3 mb-2"></div>
        {/* Two-column data lines */}
        <div className="flex justify-between w-full gap-2 border-t border-gray-100 pt-1">
          <div className="w-1/2 flex flex-col gap-1">
            <div className="h-1 bg-gray-200 rounded w-full"></div>
            <div className="h-1 bg-gray-200 rounded w-4/5"></div>
            <div className="h-1 bg-gray-200 rounded w-full"></div>
          </div>
          <div className="w-1/2 flex flex-col items-end gap-1">
            <div className="h-1 bg-gray-200 rounded w-full"></div>
            <div className="h-1 bg-gray-200 rounded w-4/5"></div>
            {/* QR Code placeholder */}
            <div className="w-3 h-3 bg-gray-500 rounded-sm mt-0.5"></div>
          </div>
        </div>
      </div>

      {/* Center Section: Text Content */}
      <div className="flex-grow text-center sm:text-left">
        <h3 className="text-[17px] font-medium text-[#1E293B] mb-1">
          Don't Miss Out on GST Invoices: Submit Details Now
        </h3>
        <p className="text-[14px] text-gray-500 leading-relaxed">
          GST details are not submitted in your profile account. Please submit
          them to receive GST invoices.
        </p>
      </div>

      {/* Right Section: Action Button */}
      <div className="flex-shrink-0 mt-2 sm:mt-0">
        <button
          onClick={() => setIsModalOpen(true)}
          className="flex items-center gap-1.5 text-[#0F766E] hover:text-[#0D9488] font-medium transition-colors group"
        >
          <CheckCircle2 className="w-5 h-5" strokeWidth={2} />
          <span className="underline decoration-[#0F766E]/40 underline-offset-4 group-hover:decoration-[#0D9488]">
            Add Details
          </span>
        </button>
      </div>

      <GstModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSubmit={handleApiCall}
      />
    </div>
  );
};

const LowBalanceAlertCard = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleApiCall = async (payload) => {
    console.log("Submitting Alert Threshold to API:", payload);
    try {
      setIsModalOpen(false); // Close immediately for mockup
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      {/* Custom CSS for High-Quality Animations */}
      <style>{`
        @keyframes float-smooth {
          0%, 100% { 
            transform: translateY(0px) rotate(0deg); 
            filter: drop-shadow(0 2px 4px rgba(59, 130, 246, 0.2));
          }
          50% { 
            transform: translateY(-5px) rotate(3deg); 
            filter: drop-shadow(0 8px 10px rgba(59, 130, 246, 0.5));
          }
        }
        
        @keyframes pulse-ring {
          0% { transform: scale(0.8); opacity: 0.6; }
          100% { transform: scale(2.2); opacity: 0; }
        }

        @keyframes shimmer-sweep {
          0% { transform: translateX(-150%) skewX(-15deg); }
          50%, 100% { transform: translateX(250%) skewX(-15deg); }
        }

        @keyframes dynamic-line {
          0%, 100% { opacity: 0.5; width: 40%; }
          50% { opacity: 1; width: 65%; }
        }
        
        @keyframes dynamic-line-short {
          0%, 100% { opacity: 0.5; width: 25%; }
          50% { opacity: 1; width: 40%; }
        }

        .animate-float-smooth {
          animation: float-smooth 3s ease-in-out infinite;
        }
        
        .animate-pulse-ring {
          animation: pulse-ring 2.5s cubic-bezier(0.215, 0.61, 0.355, 1) infinite;
        }

        .animate-shimmer {
          animation: shimmer-sweep 3s ease-in-out infinite;
        }

        .animate-line-1 {
          animation: dynamic-line 3s ease-in-out infinite;
        }
        
        .animate-line-2 {
          animation: dynamic-line-short 3s ease-in-out infinite 0.5s;
        }
      `}</style>

      <div className="flex mt-6 flex-col sm:flex-row md:flex-col 2xl:flex-row items-center justify-between border border-gray-200 rounded-xl p-4 bg-white w-full max-w-5xl mx-auto gap-4 sm:gap-6 hover:shadow-md transition-shadow duration-300">
        {/* Left Section: Wallet Graphic Thumbnail */}
        <div className="flex-shrink-0 w-32 h-20 bg-gradient-to-br from-blue-50 to-indigo-50/50 border border-blue-100 rounded-lg shadow-sm flex flex-col items-center justify-center p-2 relative overflow-hidden group cursor-pointer">
          {/* Glassy Shimmer overlay */}
          <div className="absolute inset-0 w-full h-full bg-gradient-to-r from-transparent via-white/60 to-transparent animate-shimmer pointer-events-none"></div>

          {/* Animated Pulse Ring behind Wallet */}
          <div className="absolute w-8 h-8 bg-blue-400 rounded-full animate-pulse-ring pointer-events-none"></div>

          {/* Floating Wallet Icon */}
          <div className="relative z-10 mb-2">
            <Wallet
              className="w-7 h-7 text-blue-500 animate-float-smooth"
              strokeWidth={1.5}
            />
          </div>

          {/* Animated Mock Alert Lines */}
          <div className="flex flex-col items-center gap-1.5 w-full relative z-10">
            <div className="h-1 bg-blue-300 rounded-full animate-line-1"></div>
            <div className="h-1 bg-blue-300 rounded-full animate-line-2"></div>
          </div>
        </div>

        {/* Center Section: Text Content */}
        <div className="flex-grow text-center sm:text-left">
          <h3 className="text-[17px] font-medium text-[#1E293B] mb-1">
            Stay Ahead: Configure Low Balance Alerts
          </h3>
          <p className="text-[14px] text-gray-500 leading-relaxed">
            Set Up your Low Balance Alert today to maintain sufficient balance
            and enjoy uninterrupted API services.
          </p>
        </div>

        {/* Right Section: Action Button */}
        <div className="flex-shrink-0 mt-2 sm:mt-0">
          <button
            onClick={() => setIsModalOpen(true)}
            className="flex items-center gap-1.5 px-4 py-2 rounded-lg text-blue-600 bg-blue-50 hover:bg-blue-100 hover:text-blue-700 font-medium transition-all duration-300 group"
          >
            <BellRing
              className="w-4 h-4 transition-transform group-hover:rotate-12"
              strokeWidth={2.5}
            />
            <span>Set Alert</span>
          </button>
        </div>

        <LowBalanceAlertModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        />
      </div>
    </>
  );
};
